// 设置短信验证码 smsModel 1:注册，2:登录，3:忘记密码，4:绑定手机号，5:修改手机号，6:认证，7:重置OTP，8:重置Fido，11:解绑OTP硬件令牌，12:解绑U2F硬件令牌
export function getSmsModel(key) {
    switch(key) {
        case 'unbindU2fHello':
            return 13
        case 'unbindU2f':
            return 12
        case 'unbindOtp':
            return 11
        case 'Fido':
            return 8
        case 'dynamic':
            return 7
        case 'auth':
            return 6
        case 'edit':
            return 5
        case 'bind':
            return 4
        case 'retrievePwd':
            return 3
        case 'login':
            return 2
    }
}

// 设置邮箱验证码 emailType 1:注册，2:登录，3:忘记密码，4:绑定邮箱，5:修改邮箱，6:认证，7:重置OTP，8:重置Fido，9：邮箱验证码，10：重置密码确认
export function getEmailModel(key) {
    switch(key) {
        case 'retrieve':
            return 10
        case 'login':
            return 2
        case 'editEmail':
            return 5
        case 'bind':
            return 4
        case 'auth':
            return 6
        case 'retrievePwd':
            return 3
    }
}


export function IsPC(){
    var userAgentInfo = navigator.userAgent;
    var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod","HarmonyOS","xiaomi");
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) { flag = false; break; }
    }
    return flag;
}


function detectOS() {
    // var sUserAgent = navigator.userAgent;
    var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
    var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
    if (isMac) return "Mac";
    var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
    if (isUnix) return "Unix";
    var isLinux = (String(navigator.platform).indexOf("Linux") > -1);

    //var bIsAndroid = sUserAgent.toLowerCase().match(/android/i) == "android";
    if (isLinux) {
        return "Linux"
        // if(bIsAndroid) return "Android";
        // else return "Linux";
    }
    if (isWin) {
        return "win"
        // var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
        // if (isWin2K) return "Win2000";
        // var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 ||
        //     sUserAgent.indexOf("Windows XP") > -1;
        // if (isWinXP) return "WinXP";
        // var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
        // if (isWin2003) return "Win2003";
        // var isWinVista= sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
        // if (isWinVista) return "WinVista";
        // var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
        // if (isWin7) return "Win7";
    }
    return "other";
}



export function platformType() {
    if(IsPC()){
        switch (detectOS()) {
            case 'Mac':
                return 3;
                break;
            case "win":
                return 4;
                break;
            default:
                return 5;
                break;
        }
    }else{
        if (/(iPhone|iOS)/i.test(navigator.userAgent)) {
            return 2
        }else if(/(HarmonyOS)/i.test(navigator.userAgent)) {
            return 6
        }else if (/(Android)/i.test(navigator.userAgent) || /(xiaomi)/i.test(navigator.userAgent)) {
            return 1
        }else{
            return 6
        }
    }
 }
